import { range } from 'ramda';

import { formatDatesRangeWithoutParseISO } from 'utils/itineraryDetails';

export const getTableData = (collection, minLength = 4) => {
  const longerArr = minLength > collection.length ? range(0, minLength) : collection;
  const tableData = longerArr?.map((value, index) => collection[index] || {});
  return tableData;
};

export const getFormattedTravelDates = (tourReq) => {
  const { travelStartDate: start, travelEndDate: end } = tourReq;

  if (!start) {
    return '—';
  }

  return formatDatesRangeWithoutParseISO({ start, end });
};
